// Fetch helper function
import fetch from 'helpers/Fetch';

// Import API path/routes constant
import { URL_CRM_OVERVIEW } from 'constants/api';

const fetchCustomerOverviewData = payload => {
  return fetch({
    url: URL_CRM_OVERVIEW,
    data: payload,
  });
};

export { fetchCustomerOverviewData };
